import { NORWAY } from '../keys-constants';
import { getDisponentDetaljerFields } from './disponent-detaljer';

export const isValidFnr = (fnr) => {
    if (!fnr || fnr.length !== 11) {
        return false;
    }

    const generateKontrollsiffer = (fnr, factors) => {
        const checksum = factors
            .map((factor, i) => parseInt(fnr.charAt(i), 10) * factor)
            .reduce((acc, value) => acc + value);

        const k = 11 - (checksum % 11);
        return k === 11 ? 0 : k;
    };

    const k1 = generateKontrollsiffer(fnr, [3, 7, 6, 1, 8, 9, 4, 5, 2]);
    const k2 = generateKontrollsiffer(fnr, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]);

    return k1 === parseInt(fnr.charAt(9), 10) && k2 === parseInt(fnr.charAt(10), 10);
};

export const answersToManager = (answers) =>
    Object.keys(getDisponentDetaljerFields()).reduce(
        (previousValue, key) => ({
            ...previousValue,
            [key]: answers[key],
        }),
        {}
    );

export const isValidDisponent = (key, manager = getDisponentDetaljerFields(), config, postalCodesList) => {
    const value = manager[key];
    switch (key) {
        case 'postnummer':
            if (config && config.addressInformationOptional) return true;
            if (postalCodesList && manager.bostedsland === NORWAY) return postalCodesList.includes(value);
            return value && value.trim().length > 0;
        case 'navn':
        case 'fodeland':
        case 'statsborgerskap':
        case 'adresse':
        case 'poststed':
        case 'bostedsland':
            return (value && value.trim().length > 0) || false;
        case 'fnr':
            return value && isValidFnr(value.trim());
        case 'pep':
            return typeof value === 'boolean';
        case 'pepVerv':
        case 'pepRelasjon':
            return manager.pep ? value && value.trim().length > 0 : true;
        default:
            return true;
    }
};
